export default "__VITE_ASSET__C_On_Anl__"